/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Art_State_1Inputs */

const en_svc_n8n_art_state_1 = /** @type {(inputs: Svc_N8n_Art_State_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const lv_svc_n8n_art_state_1 = /** @type {(inputs: Svc_N8n_Art_State_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pabeigts`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Svc_N8n_Art_State_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_art_state_1 = /** @type {((inputs?: Svc_N8n_Art_State_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Art_State_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_art_state_1(inputs)
	return en_svc_n8n_art_state_1(inputs)
});